import styled from '@emotion/styled';
import {
  GenericWizardModalBody,
  GenericWizardSection,
} from 'components/GenericWizard';

export const StyledGenericWizardModalBody = styled(GenericWizardModalBody)`
  padding: 1px 45px 0px 35px;
`;

export const StyledUploadDataSection = styled(GenericWizardSection)`
  margin-top: 12px;
  margin-bottom: 28px;
`;

export const StyledMatchRecordsSection = styled(GenericWizardSection)`
  margin-top: 12px;
  margin-bottom: 29px;
`;

export const StyledFinalizeUploadSection = styled(GenericWizardSection)`
  margin-top: 20px;
`;
export const CategoryWrapper = styled.div`
  align-items: center;
  margin-top: 15px;
  padding-bottom: 2px;
`;
export const SpanName = styled.span`
  font-size: inherit;
  font-weight: inherit;
  color: var(--color-font-placeholder);
`;
